import { CustomerLayout } from "@/components/CustomerLayout/CustomerLayout";
import { DocumentSikring } from "@/components/DocumentSikring/DocumentSikring";
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated-user/oppdrag/$tluxCaseId/sikring/$sikringId/")({
  loader: async ({ params }) => {
    const { tluxCaseId, sikringId } = params;

    const res = await routeLoaderApiClient.oppdrag[":tluxCaseId"].sikring[":sikringId"].$get({
      param: {
        tluxCaseId,
        sikringId,
      },
    });

    if (res.ok === false) {
      throw new Error("Failed to fetch sikring");
    }

    return {
      sikring: await res.json(),
    };
  },
  head: () => ({
    meta: [{ title: "Rediger sikring | Alice & Bob" }],
  }),
  component: Page,
});

function Page() {
  const { tluxCaseId, sikringId } = Route.useParams();
  const { sikring } = Route.useLoaderData();

  return (
    <CustomerLayout>
      <DocumentSikring
        tluxCaseId={tluxCaseId}
        sikringId={sikringId}
        sikring={sikring}
        cancelUrl={`/oppdrag/${tluxCaseId}`}
      />
    </CustomerLayout>
  );
}
